import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as GeneralActions from '@states/general/general.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { GeneralService } from '@states/general/general.service';
import * as SharedActions from '@states/shared/shared.actions';

@Injectable()
export class GeneralEffect {
  constructor(private actions$: Actions, private store$: Store<AppState>, private generalService: GeneralService) { }

  public getGeneralFromBackend$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeneralActions.getGeneralFromBackend),
      switchMap(() => {
        return this.generalService.getGeneralSettings().pipe(
          map(res => {
            return GeneralActions.setGeneral({ generalState: res });
          }),
          catchError(err => {
            return of(SharedActions.consoleMessage({ error: err.message || 'Error loading general state' }));
          })
        );
      })
    )
  );
}
